import type { ColumnDef } from '@tanstack/react-table';
import { createSerialColumn, StackedCellText } from '@/components/common/DataTable';
import { EMPTY_VALUE } from '@/constants/app.constants';
import { joinAreaNames } from '@/utils/areaNames';
import { formatDisplayDate, formatTime } from '@/utils/date';
import { formatNumber } from '@/utils/number';
import type { DonationCandidateLine } from '../types/marketPromotionP2.types';
import { InstituteNumbers } from '@/components/common/InstituteNumbers';

export const DONATION_LINE_DATE_COLUMN_ID = 'dcrDate';

export function getDonationCandidateLineColumns(): ColumnDef<DonationCandidateLine, unknown>[] {
  return [
    createSerialColumn<DonationCandidateLine>(),
    {
      id: DONATION_LINE_DATE_COLUMN_ID,
      header: 'Date',
      cell: ({ row }) => (
        <StackedCellText
          primary={formatDisplayDate(row.original.dcrDate)}
          primaryClassName="font-medium"
          secondary={`Entered ${formatTime(row.original.enteredAt)}`}
        />
      ),
    },
    {
      id: 'institute',
      header: 'Institute',
      cell: ({ row }) => (
        <StackedCellText
          primary={row.original.instituteName ?? EMPTY_VALUE}
          secondary={
            <InstituteNumbers code={row.original.instituteCode} eiin={row.original.instituteEiin} />
          }
          tertiary={joinAreaNames([row.original.instituteThana, row.original.instituteDistrict])}
        />
      ),
    },
    {
      id: 'teacher',
      header: 'Teacher',
      cell: ({ row }) => (
        <StackedCellText
          primary={row.original.teacherName ?? EMPTY_VALUE}
          secondary={row.original.teacherMobile}
        />
      ),
    },
    {
      id: 'itemName',
      header: 'Donation Name',
      cell: ({ row }) => row.original.itemName,
    },
    {
      id: 'amount',
      header: 'Amount (Tk)',
      cell: ({ row }) => (
        <span className="tabular-nums">{formatNumber(Math.round(row.original.amount))}</span>
      ),
    },
  ];
}
